interface IPayload {
    id: number;
    status: "PENDING" | "ACCEPT" | "REJECT" | "NEW";
}

export const updateOrderStatus = (payload: IPayload) => ({
    type: "@saga/UPDATE_ORDER_STATUS",
    payload
});